<template>
  <div class="invite-wrapper">
    <div class="invite-bg"></div>
    <div class="invite-main">
      <div class="invite-header">
        <div class="doctor-title">
          <h2>{{codeInfo.username}}医生</h2>
          <h3>{{codeInfo.title | jobTitleFilter}}</h3>
        </div>
        <p class="doctor-job">{{codeInfo.p_dep}} | {{codeInfo.dep}}</p>
        <p class="doctor-hospital">{{codeInfo.work_unit}}</p>
      </div>
      <div class="qrcode-box">
        <div class="code-box">
          <div class="code-title">{{codeInfo.username}}医生的邀请码</div>
          <div class="code">{{codeInfo.code}}</div>
        </div>
        <div class="qrcode"><img :src="codeInfo.url" v-if="codeInfo.url"></div>
        <p>打开微信扫一扫，添加医生</p>
      </div>
    </div>
    <!-- <div class="save-button"><button>保存到相册</button></div> -->
  </div>
</template>

<style lang="less" scoped>
  .invite-wrapper{
    padding: 0 20px;
  }
  .invite-bg{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 200px;
    background: @linear;
    z-index: 1;
  }
  .invite-main{
    position: relative;
    z-index: 10;
    margin-top: 40px;
    background: #FFF;
    box-shadow: 0px 4px 10px 0px rgba(51,51,51,0.08);
    border-radius: 6px;
    &::after{
      content: '';
      position: absolute;
      left: 50%;
      top: -40px;
      transform: translateX(-50%);
      width: 24px;
      height: 55px;
      background: #7C9CC5;
    }
    &::before{
      content: '';
      position: absolute;
      left: 50%;
      top: 12px;
      transform: translateX(-50%);
      width: 48px;
      height: 8px;
      border-radius: 5px;
      background: @xile;
    }
    .invite-header{
      padding: 34px 20px 24px;
      width: 100%;
      // height: 98px;
      .xile-alpha(0.15);
      color: @xile;
      border-radius: 6px 6px 0 0;
      .doctor-title{
        display: flex;
        justify-content: flex-start;
        align-items: baseline;
        h2{
          font-size: 18px;
          font-weight: normal;
        }
        h3{
          margin-left: 8px;
          font-size: 14px;
          font-weight: normal;
        }
      }
      .doctor-job{
        margin-top: 8px;
        font-size: 14px;
        line-height: 14px;
      }
      .doctor-hospital{
        margin-top: 12px;
        font-size: 14px;
        line-height: 14px;
      }
    }
    .qrcode-box{
      text-align: center;
      padding-bottom: 56px;
      .code-box{
        padding: 20px 0 23px;
        width: 200px;
        margin: 0 auto;
        border-bottom: 1px solid #EEE;
        .code-title{
          font-size: 14px;
          line-height: 20px;
          color: #666;
          font-weight: normal;
        }
        .code{
          width: 160px;
          margin: 8px auto 0;
          height: 40px;
          line-height: 40px;
          color: @xile;
          font-size: 20px;
          font-weight: bold;
          .xile-alpha(0.05);
        }
      }
      .qrcode{
        width: 200px;
        height: 200px;
        margin: 32px auto 0;
        img{
          width: 100%;
          // pointer-events: none;
        }
      }
      p{
        margin-top: 16px;
        font-size: 14px;
        line-height: 14px;
        color: #666;
      }
    }
  }
  .save-button{
    margin: 40px auto 0;
    width: 240px;
    button{
      @button-base();
      width: 100%;
      height: 36px;
      font-size: 14px;
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        doc_id:this.$route.query.doc_id,
        codeInfo: {}
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      let _this=this;
      // 获取微信sdk签名
      let url = encodeURIComponent(window.location.href.split('#')[0])
      console.log(url)
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
         console.log(data)
        if (data) {

          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
          });
        }
      });
      this.$root.post('/teamQrCode', {
        doc_id: this.doc_id,
        user_id: this.userInfo.user_id
      }).then(data => {
        console.log(data);
        this.codeInfo = data;

        wx.onMenuShareAppMessage({
          "title": '向你推荐了'+data.username+'医生',
          "desc": '喜乐互联网医院',
          'link': 'http://v2.xilezaixian.com/shareDocCode?doc_id=' + _this.doc_id+'&user_id='+this.userInfo.user_id,
          "imgUrl": data.avatar,
        }, function(res) {
          console.log(res)
        });
        wx.onMenuShareTimeline({
          title: '向你推荐了'+data.username+'医生',
          link: 'http://v2.xilezaixian.com/shareDocCode?doc_id=' + _this.doc_id+'&user_id='+this.userInfo.user_id,
          imgUrl: data.avatar,
          success: function() {

          },
          cancel: function() {

          }
        });

      })

    }

  }
</script>



// WEBPACK FOOTER //
// src/components/Public/docQrCodeShare.vue